import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class Actions extends BaseComponent {
  render() {
    let copyBtn;
    if (this.props.allowCopy !== false) {
      copyBtn = <i className="material-icons" onClick={this.props.copyLegend}>content_copy</i>;
    }
    return (
      <div className={styles.actions}>
        <i className="material-icons" onClick={this.props.closeLegendConfig}>close</i>
        {copyBtn}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/actions.jsx